import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail, Twitter, Linkedin } from 'lucide-react';

export default function IrreplacableFooter() {
  const navigate = useNavigate();
  
  return (
    <footer className="bg-dark py-12 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo and Description */}
          <div className="col-span-2">
            <img 
              src="https://firebasestorage.googleapis.com/v0/b/insightalks-47e16.firebasestorage.app/o/ITLss-white.svg?alt=media&token=062a9f72-4dcd-4185-b0be-9f5aecf9943c" 
              alt="InsighTalks" 
              className="h-10 mb-4 object-contain"
            />
            <p className="text-gray-400 max-w-md">
              Transform feedback into actionable insights. Elevate your professional growth with comprehensive, structured evaluations.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <a href="#features" className="text-gray-400 hover:text-white transition-colors">
                  Features
                </a>
              </li>
              <li>
                <a href="#how-it-works" className="text-gray-400 hover:text-white transition-colors">
                  How it Works
                </a>
              </li>
              <li>
                <a href="#pricing" className="text-gray-400 hover:text-white transition-colors">
                  Pricing
                </a>
              </li>
              <li>
                <a 
                  href="https://www.iubenda.com/privacy-policy/37806061" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Privacy Policy
                </a>
              </li>
              <li>
                <a 
                  href="https://www.iubenda.com/privacy-policy/37806061/cookie-policy" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Cookie Policy
                </a>
              </li>
              <li>
                <a 
                  href="https://www.iubenda.com/terms-and-conditions/37806061" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Terms and Conditions
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-semibold mb-4">Connect With Us</h3>
            <div className="space-y-4">
              <button
                onClick={() => navigate('/contact')}
                className="bg-primary text-dark px-6 py-2 rounded-lg hover:bg-primary-hover transition-colors w-full"
              >
                Contact Us
              </button>
              <div className="flex space-x-4">
                <a 
                  href="mailto:voice@insightalks.com"
                  className="text-gray-400 hover:text-white transition-colors"
                  aria-label="Email"
                >
                  <Mail className="w-5 h-5" />
                </a>
                <a 
                  href="https://twitter.com/insightalks"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-white transition-colors"
                  aria-label="Twitter"
                >
                  <Twitter className="w-5 h-5" />
                </a>
                <a 
                  href="https://linkedin.com/company/insightalks"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-white transition-colors"
                  aria-label="LinkedIn"
                >
                  <Linkedin className="w-5 h-5" />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="text-center text-gray-400">
            <p>
              &copy; {new Date().getFullYear()} InsighTalks. All rights reserved. By using this site, you agree to our{' '}
              <a 
                href="https://www.iubenda.com/terms-and-conditions/37806061" 
                target="_blank" 
                rel="noopener noreferrer"
                className="underline hover:text-white transition-colors"
              >
                Terms of Service
              </a>
              {' '}and{' '}
              <a 
                href="https://www.iubenda.com/privacy-policy/37806061" 
                target="_blank" 
                rel="noopener noreferrer"
                className="underline hover:text-white transition-colors"
              >
                Privacy Policy
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}